<template v-if="poll && brand">
  <div :class="getPollClasses()">
    <div class="bx-poll__question">
      {{ poll.question }}
    </div>
    <form class="bx-form bx-typo--form"
          onsubmit="return false;">
      <ul>
        <li v-for="(item, index) in poll.answers"
            :key="`poll-${listOrderPosition}-a${index}`">
          <input v-if="!voted"
                 :id="`poll-${listOrderPosition}-a${index}`"
                 v-model="picked"
                 :name="poll.question"
                 :value="index"
                 type="radio">
          <div v-else>
            <progress max="100"
                      :value="percentages[index]">
              {{ percentages[index] }}
            </progress>
            <span>
              <strong>{{ percentages[index] }}%</strong>
            </span>
          </div>
          <label :for="`poll-${listOrderPosition}-a${index}`">
            {{ item.answer }}
            <span v-if="voted">{{ votes[index] }}</span>
          </label>
        </li>
      </ul>
      <button v-if="!voted"
              :disabled="picked < 0"
              class="bx-form__button bx-poll__button"
              @click="submit">
        Abstimmen
      </button>
    </form>
  </div>
</template>

<script>

import { mapState } from 'pinia'
import { ref } from 'vue'

import { getAxios } from '../../api/axios'
import { useConfigStore } from '../../stores/config'
import { useAdaMoltenBundle } from '../../composables/use-ada-molten-bundle'
import { useDeviceDetection } from '../../composables/use-device-detection'

export default {

  props: {
    poll: {
      type: Object,
      default: () => {}
    },
    brand: {
      type: String,
      default: ''
    },
    listOrderPosition: {
      type: Number,
      default: 0
    }
  },
  setup () {
    const { deviceType } = useDeviceDetection()
    const registerSlots = ref([])
    const moltenBundle = useAdaMoltenBundle({ registerSlots, deviceType })
    return { deviceType, registerSlots, ...moltenBundle }
  },
  data () {
    return {
      voted: false,
      picked: -1,
      votes: [1, 2, 3, 4, 5],
      sumVotes: 0,
      percentages: []
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig']),
    reloadAdsOnInteraction () {
      return this.rsConfig.adSlotUsage.reloadAdsOnInteraction
    }
  },
  methods: {
    async submit () {
      try {
        const axios = await getAxios()
        const response = await axios.post(
          `${this.rsConfig.hotOrNotServiceUrl}/poll/${this.brand}/${this.poll.reference.assetId}`,
          { vote: this.picked })
        this.votes = response.data
        this.percentage = this.calcPercentages(this.votes)
        this.voted = true
        if (this.reloadAdsOnInteraction.enabled) {
          this.adaSlotReloadOnInteraction(this.reloadAdsOnInteraction.config)
        }
      } catch (e) {
        console.log('error posting poll: ', e)
      }
    },
    calcPercentages (votes) {
      this.sumVotes = votes.reduce((acc, val) => { return acc + val }, 0)
      this.percentages = votes.map((val) => { return Math.round(100 / this.sumVotes * val) })
    },
    getPollClasses () {
      return {
        'bx-content': true,
        'bx-content__continuous-text': true,
        'bx-typo--content-continuous-text': true,
        'bx-poll': true,
        'bx-poll--voted': this.voted,
        'bx-typo--poll': true
      }
    }
  }
}
</script>
